import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { Request } from '../../../../httpClient/serverApi/requests/Request';

export interface IAddKeyPairAuthCredentialRequest {
  server: string;
  role: string;
  username: string;
  privateKey: string;
  privateKeyPassword: string;
  dbClass: string;
}

export interface IAddKeyPairAuthCredentialResult extends IResult {
  id: string;
}

export class AddKeyPairAuthCredentialRequest extends Request<IAddKeyPairAuthCredentialRequest, IAddKeyPairAuthCredentialResult> {
  constructor(params: IAddKeyPairAuthCredentialRequest) {
    super('addKeyPairAuthCredential', params);
  }
}